module.exports = ".bg-primary{\n    background-color:#ea1f25!important;\n}"